import { createContext, useContext, useState, type ReactNode } from 'react';

/**
 * Open recommendations for the site in view, for the SEO group in the
 * sidebar. Shell provides it; the layout (and the Recommendations page,
 * as cards are marked) sets it. Null when not known.
 *
 * Its own module, not SeoLayout's: Shell is in every signed-in page's
 * first load, and SeoLayout brings the SEO report and its charts
 * (recharts), which only the SEO pages use. Those load with their route
 * (App.tsx).
 */
const OpenRecsContext = createContext<{ open: number | null; setOpen: (n: number | null) => void }>({ open: null, setOpen: () => {} });

export function OpenRecsProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState<number | null>(null);
  return <OpenRecsContext.Provider value={{ open, setOpen }}>{children}</OpenRecsContext.Provider>;
}
export const useOpenRecs = () => useContext(OpenRecsContext);
